import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { ShopperSocialGroupPage } from './shopper-social-group';

@NgModule({
  declarations: [
    ShopperSocialGroupPage,
  ],
  imports: [
    IonicPageModule.forChild(ShopperSocialGroupPage),
    TranslateModule.forChild()
  ],
})
export class ShopperSocialGroupPageModule {}



// WEBPACK FOOTER //
// ./src/pages/shopper-social-group/shopper-social-group.module.ts